import { brand } from './site';
import { getMessages } from '../i18n/locale';

// Page structure stays language neutral; text lives in src/locales/*.json.
export const modules = {
  products: { path: '/products', number: '01' },
  'open-source': { path: '/open-source', number: '02' },
  services: { path: '/services', number: '03' },
  docs: { path: '/docs', number: '04' },
  community: { path: '/community', number: '05' },
  company: { path: '/company', number: '06' },
};

export function getModule(key, locale) {
  const structure = modules[key];
  const copy = getMessages(locale).modules[key];
  if (!structure || !copy) return null;
  return {
    ...structure,
    ...copy,
    description: copy.description.replaceAll('{brand}', brand.name),
    slots: copy.slots.map((slot, index) => ({
      ...slot,
      number: String(index + 1).padStart(2, '0'),
      ...(key === 'company' && index === 2 ? { href: '/company/contact' } : {}),
    })),
  };
}
